export function normalizeAdminManagedUser(userRecord = {}) {
  return {
    id: userRecord.id ?? userRecord.user_id ?? userRecord.userId ?? "",
    email: userRecord.email ?? "",
    displayName:
      userRecord.display_name ??
      userRecord.displayName ??
      userRecord.full_name ??
      userRecord.fullName ??
      "",
    firstName: userRecord.first_name ?? userRecord.firstName ?? "",
    lastName: userRecord.last_name ?? userRecord.lastName ?? "",
    createdAt:
      userRecord.created_at ??
      userRecord.createdAt ??
      userRecord.created_on ??
      userRecord.createdOn ??
      null,
    lastSignInAt: userRecord.last_sign_in_at ?? userRecord.lastSignInAt ?? null,
    lastActiveAt: userRecord.last_active_at ?? userRecord.lastActiveAt ?? null,
    role: userRecord.role ?? userRecord.user_role ?? userRecord.userRole ?? "",
    organization: userRecord.organization ?? userRecord.org ?? userRecord.Organization ?? "",
    phone: userRecord.phone ?? userRecord.phone_number ?? userRecord.phoneNumber ?? "",
    demoModeEnabled: Boolean(userRecord.demo_mode_enabled ?? userRecord.demoModeEnabled ?? false),
    demoLocked: Boolean(userRecord.demo_locked ?? userRecord.demoLocked ?? false),
    demoStartedAt:
      userRecord.demo_started_at ??
      userRecord.demoStartedAt ??
      userRecord.demo_start_at ??
      userRecord.demoStartAt ??
      null,
    demoActiveDays: Number(userRecord.demo_active_days ?? userRecord.demoActiveDays ?? 0) || 0,
    demoRemainingDays:
      Number(userRecord.demo_remaining_days ?? userRecord.demoRemainingDays ?? 0) || 0,
    demoMarketOptimizationLimitPerDay:
      Number(
        userRecord.demo_market_optimization_limit_per_day ??
          userRecord.demoMarketOptimizationLimitPerDay ??
          0
      ) || 0,
    demoFeasibilityLimitPerDay:
      Number(userRecord.demo_feasibility_limit_per_day ?? userRecord.demoFeasibilityLimitPerDay ?? 0) ||
      0,
    marketOptimizationRemainingToday:
      Number(
        userRecord.market_optimization_remaining_today ??
          userRecord.marketOptimizationRemainingToday ??
          0
      ) || 0,
    feasibilityRemainingToday:
      Number(userRecord.feasibility_remaining_today ?? userRecord.feasibilityRemainingToday ?? 0) || 0,
    demoCanSubmitBids: Boolean(
      userRecord.demo_can_submit_bids ?? userRecord.demoCanSubmitBids ?? false
    ),
    demoMarketOperationsEnabled: Boolean(
      userRecord.demo_market_operations_enabled ?? userRecord.demoMarketOperationsEnabled ?? false
    ),
    demoWindSystemEnabled: Boolean(
      userRecord.demo_wind_system_enabled ?? userRecord.demoWindSystemEnabled ?? false
    ),
    demoMarketDataEnabled: Boolean(
      userRecord.demo_market_data_enabled ?? userRecord.demoMarketDataEnabled ?? false
    ),
    demoMerchantEnabled: Boolean(
      userRecord.demo_merchant_enabled ?? userRecord.demoMerchantEnabled ?? true
    ),
    demoPpaEnabled: Boolean(
      userRecord.demo_ppa_enabled ?? userRecord.demoPpaEnabled ?? false
    ),
    demoTollingEnabled: Boolean(
      userRecord.demo_tolling_enabled ?? userRecord.demoTollingEnabled ?? false
    ),
    demoMultipleAssetsEnabled: Boolean(
      userRecord.demo_multiple_assets_enabled ?? userRecord.demoMultipleAssetsEnabled ?? false
    ),
    regularMarketOperationsEnabled: Boolean(
      userRecord.regular_market_operations_enabled ?? userRecord.regularMarketOperationsEnabled ?? true
    ),
    regularCanSubmitBids: Boolean(
      userRecord.regular_can_submit_bids ?? userRecord.regularCanSubmitBids ?? true
    ),
    regularWindSystemEnabled: Boolean(
      userRecord.regular_wind_system_enabled ?? userRecord.regularWindSystemEnabled ?? true
    ),
    regularMarketDataEnabled: Boolean(
      userRecord.regular_market_data_enabled ?? userRecord.regularMarketDataEnabled ?? true
    ),
    regularFeasibilityEnabled: Boolean(
      userRecord.regular_feasibility_enabled ?? userRecord.regularFeasibilityEnabled ?? true
    ),
    regularMerchantEnabled: Boolean(
      userRecord.regular_merchant_enabled ?? userRecord.regularMerchantEnabled ?? true
    ),
    regularPpaEnabled: Boolean(
      userRecord.regular_ppa_enabled ?? userRecord.regularPpaEnabled ?? false
    ),
    regularTollingEnabled: Boolean(
      userRecord.regular_tolling_enabled ?? userRecord.regularTollingEnabled ?? false
    ),
    regularMonitoringEnabled: Boolean(
      userRecord.regular_monitoring_enabled ?? userRecord.regularMonitoringEnabled ?? false
    ),
    regularMultipleAssetsEnabled: Boolean(
      userRecord.regular_multiple_assets_enabled ?? userRecord.regularMultipleAssetsEnabled ?? false
    ),
    regularMarketOptimizationLimitPerDay:
      userRecord.regular_market_optimization_limit_per_day ?? userRecord.regularMarketOptimizationLimitPerDay ?? null,
    regularFeasibilityLimitPerDay:
      userRecord.regular_feasibility_limit_per_day ?? userRecord.regularFeasibilityLimitPerDay ?? null,
    regularMaxProjects: userRecord.regular_max_projects ?? userRecord.regularMaxProjects ?? null,
    regularMaxSimulationDays:
      userRecord.regular_max_simulation_days ?? userRecord.regularMaxSimulationDays ?? null,
    regularMarketOptimizationRemainingToday:
      userRecord.regular_market_optimization_remaining_today ?? userRecord.regularMarketOptimizationRemainingToday ?? null,
    regularFeasibilityRemainingToday:
      userRecord.regular_feasibility_remaining_today ?? userRecord.regularFeasibilityRemainingToday ?? null,
    accessUpdatedAt: userRecord.access_updated_at ?? userRecord.accessUpdatedAt ?? null,
    accessUpdatedBy: userRecord.access_updated_by ?? userRecord.accessUpdatedBy ?? null,
    lastSeenPlatformVersion:
      userRecord.last_seen_platform_version ?? userRecord.lastSeenPlatformVersion ?? null,
    lastSeenPlatformVersionAt:
      userRecord.last_seen_platform_version_at ?? userRecord.lastSeenPlatformVersionAt ?? null,
  };
}

const REGULAR_ACCESS_FIELDS = {
  regularMarketOperationsEnabled: "market_operations_enabled",
  regularCanSubmitBids: "can_submit_bids",
  regularWindSystemEnabled: "wind_system_enabled",
  regularMarketDataEnabled: "market_data_enabled",
  regularFeasibilityEnabled: "feasibility_enabled",
  regularMerchantEnabled: "merchant_enabled",
  regularPpaEnabled: "ppa_enabled",
  regularTollingEnabled: "tolling_enabled",
  regularMonitoringEnabled: "monitoring_enabled",
  regularMultipleAssetsEnabled: "multiple_assets_enabled",
  regularMarketOptimizationLimitPerDay: "market_optimization_limit_per_day",
  regularFeasibilityLimitPerDay: "feasibility_limit_per_day",
  regularMaxProjects: "max_projects",
  regularMaxSimulationDays: "max_simulation_days",
};

export function buildManagedUserAccessPayload(managedUser, persistedUser) {
  const result = {};
  for (const [clientField, apiField] of Object.entries(REGULAR_ACCESS_FIELDS)) {
    const isBoolean = clientField.endsWith("Enabled") || clientField === "regularCanSubmitBids";
    const normalize = (value) => isBoolean
      ? Boolean(value)
      : (value === "" || value == null ? null : Number(value));
    const next = normalize(managedUser?.[clientField]);
    const current = normalize(persistedUser?.[clientField]);
    if (next !== current) result[apiField] = next;
  }
  return result;
}

export function normalizeAdminFlag(profile, user) {
  const rawRole =
    profile?.role ??
    profile?.user_role ??
    profile?.userRole ??
    user?.app_metadata?.role ??
    user?.user_metadata?.role ??
    "";

  return Boolean(
    profile?.is_admin ??
      profile?.isAdmin ??
      user?.app_metadata?.is_admin ??
      user?.user_metadata?.is_admin ??
      String(rawRole).toLowerCase() === "admin"
  );
}

export function buildManagedUserDemoPayload(managedUser) {
  return {
    demo_mode_enabled: Boolean(managedUser?.demoModeEnabled),
    ...(managedUser?.demoStartedAt ? { demo_started_at: managedUser.demoStartedAt } : {}),
    demo_active_days: Number(managedUser?.demoActiveDays) || 0,
    demo_market_optimization_limit_per_day:
      Number(managedUser?.demoMarketOptimizationLimitPerDay) || 0,
    demo_feasibility_limit_per_day: Number(managedUser?.demoFeasibilityLimitPerDay) || 0,
    demo_can_submit_bids: Boolean(managedUser?.demoCanSubmitBids),
    demo_market_operations_enabled: Boolean(managedUser?.demoMarketOperationsEnabled),
    demo_wind_system_enabled: Boolean(managedUser?.demoWindSystemEnabled),
    demo_market_data_enabled: Boolean(managedUser?.demoMarketDataEnabled),
    demo_merchant_enabled: Boolean(managedUser?.demoMerchantEnabled),
    demo_ppa_enabled: Boolean(managedUser?.demoPpaEnabled),
    demo_tolling_enabled: Boolean(managedUser?.demoTollingEnabled),
    demo_multiple_assets_enabled: Boolean(managedUser?.demoMultipleAssetsEnabled),
  };
}

function normalizeOptionalText(value) {
  const trimmed = String(value ?? "").trim();
  return trimmed || null;
}

export function buildManagedUserProfilePayload(managedUser, persistedUser) {
  const nextFields = {
    first_name: normalizeOptionalText(managedUser?.firstName),
    last_name: normalizeOptionalText(managedUser?.lastName),
    organization: normalizeOptionalText(managedUser?.organization),
    phone: normalizeOptionalText(managedUser?.phone),
  };

  const currentFields = {
    first_name: normalizeOptionalText(persistedUser?.firstName),
    last_name: normalizeOptionalText(persistedUser?.lastName),
    organization: normalizeOptionalText(persistedUser?.organization),
    phone: normalizeOptionalText(persistedUser?.phone),
  };

  return Object.fromEntries(
    Object.entries(nextFields).filter(([key, value]) => value !== currentFields[key])
  );
}

